
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/socket.io-client/~/engine.io-client/index.js
 ** module id = 15
 ** module chunks = 0
 **/